import { render, staticRenderFns } from "./AddBankAccount.vue?vue&type=template&id=3145782e&scoped=true&"
import script from "./AddBankAccount.vue?vue&type=script&lang=js&"
export * from "./AddBankAccount.vue?vue&type=script&lang=js&"
import style0 from "./AddBankAccount.vue?vue&type=style&index=0&id=3145782e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3145782e",
  null
  
)

export default component.exports